export const setupSiteSearch = (): void => {
  const siteSearch = document.querySelector('.site-search');
  if (siteSearch) {
    siteSearch.addEventListener('click', () => {
      const searchToggle = document.querySelector('.search-toggle') as HTMLButtonElement;
      if (searchToggle) {
        searchToggle.click();
      }
    });
  }
};
